<template>
  <transition name="modal" appear>
    <div class="main-modal main-modal-overlay" @click.self="$emit('closeModal')">
      <div class="main-modal-window">
        <div class="main-modal-container">
          <slot name="modal"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.main-modal {
  &-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  &-window {
    width: 95%;
    min-width: 400px;
    margin: auto;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    font-size: 13px;
  }

  &-container {
    // padding: 10px 10px;
    &_block {
      margin-bottom: 5px;
      text-align: left;
      p {
        margin: 0;
        display: inline-block;
        font-weight: bold;
        color: $base_text_color;
        font-size: 14px;
        padding: 5px 5px;
      }
      &_text {
        // padding: 0 15px;
      }
      &_child {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        // padding: 0 15px;
        p {
          width: calc((100% - 100px) / 3);
          // margin-bottom: 5px;
        }
      }
    }
  }
  &-button {
    padding: 0 10px 10px 10px;
    &_item {
      button {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 8px;
        box-sizing: border-box;
        border-radius: 5px;
        outline: none;
        border: none;
      }
      .cancel {
        color: $base_text_color;
        margin-bottom: 10px;
        background: none;
      }
      .done {
        position: relative;
        background: $button_color;
        color: #ffffff;
        border-radius: 50px;
        box-shadow: $box_shadow;
        // display: flex;
        // align-items: center;
        svg {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }
  }
}

// オーバーレイのトランジション
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .modal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.modal-leave-active {
  transition: opacity 0.4s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
// .loader {
//   color: #ffffff;
//   font-size: 15px;
//   width: 1em;
//   height: 1em;
//   border-radius: 50%;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   animation: load4 1.3s infinite linear;
// }
// @-webkit-keyframes load4 {
//   0%,
//   100% {
//     box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
//   }
//   12.5% {
//     box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
//   }
//   25% {
//     box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0,
//       0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
//   }
//   37.5% {
//     box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em,
//       0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
//   }
//   50% {
//     box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em,
//       0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
//   }
//   62.5% {
//     box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
//   }
//   75% {
//     box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
//   }
//   87.5% {
//     box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
//   }
// }
// @keyframes load4 {
//   0%,
//   100% {
//     box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
//   }
//   12.5% {
//     box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
//   }
//   25% {
//     box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0,
//       0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
//   }
//   37.5% {
//     box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em,
//       0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
//   }
//   50% {
//     box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em,
//       0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
//   }
//   62.5% {
//     box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
//   }
//   75% {
//     box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
//   }
//   87.5% {
//     box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em,
//       0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
//   }
// }
</style>
